import {Account, AccountActionTypes, REMOVE_ACCOUNT, SET_ACCOUNT, SET_ACCOUNT_ERROR, CLEAR_ACCOUNT_ERROR} from "./types";


export function removeAccount(): AccountActionTypes {
    return {
        type: REMOVE_ACCOUNT
    }
}

export function selectAccount(data: Account): AccountActionTypes {
    return {
        type: SET_ACCOUNT,
        payload: data
    };
}

export function setAccountError(message: string): AccountActionTypes {
    return {
        type: SET_ACCOUNT_ERROR,
        payload: message
    };
}

export function clearAccountError(): AccountActionTypes {
    return {
        type: CLEAR_ACCOUNT_ERROR
    };
}